class Export {

  static add(type, value) {
    let username = localStorage.getItem("tie-username");

    //to avoid problems with identification
    type = type.toLowerCase();

    let item = {
      key: type + "/" + value.id,
      id: value.id,
      revision: value.revision,
      type: type,
      name: value.name,
      user: username,
      lastModified: value.lastModified,
      lastModifiedBy: value.modifiedBy,
      active: value.active
    };

    let items = Export.load();
    let notFound = items.find(f => f.type === type && f.name === value.name) === undefined;
    if(notFound) {
      items.push(item);
      localStorage.setItem("tie-export-" + username, JSON.stringify(items));
    }

    window.dispatchEvent(new Event("export-count-event"));
  }

  static remove(type, name) {
    //to avoid problems with identification
    type = type.toLowerCase();

    let username = localStorage.getItem("tie-username");
    let items = Export.load();
    if(items) {
      var filtered = items.filter(f => !(f.type === type && f.name === name));
      localStorage.setItem("tie-export-" + username, JSON.stringify(filtered));
    }

    window.dispatchEvent(new Event("export-count-event"));
  }

  static load() {
    let username = localStorage.getItem("tie-username");
    let data = localStorage.getItem("tie-export-" + username);
    if(data) {
      return JSON.parse(data);
    }
    return [];
  }

  static clear() {
    let username = localStorage.getItem("tie-username");
    localStorage.removeItem("tie-export-" + username);
  }

}

export default Export;
